import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useMe } from "../../api/hooks";
import { PageHead } from "../../components/shell/Page";
import { t } from "../../i18n";

/** Admin screens: members who open one directly get a plain explanation, not the page. */
export const Route = createFileRoute("/_app/admin")({ component: AdminOnly });

function AdminOnly() {
  const me = useMe();
  if (me.data?.role === "admin") return <Outlet />;
  return (
    <main className="sub main on no-panel" aria-label={t("shell.adminsOnly")}>
      <div className="page">
        <PageHead title={t("shell.adminsOnly")} />
        <div className="page-body scroll">
          <div className="empty">
            <h2>{t("shell.adminsOnlyHeading")}</h2>
            <p>{t("shell.adminsOnlyBody")}</p>
          </div>
        </div>
      </div>
    </main>
  );
}
